export function plansPath() {
  return '/plans';
}
